// @flow
import React, { Component } from "react";
import { List, Map } from "immutable";
import Grid from "@material-ui/core/Grid";
import LoaderBig from "components/LoaderBig";
import Paper from "@material-ui/core/Paper";

import HelpToolbar from "./HelpToolbar";
import HelpMenu from "./HelpMenu";
import HelpContent from "./HelpContent";

type Props = {
  topicKey: ?string,
  dto: ?Map<string, any>,
  loading: boolean,
  action: () => void,
  updateTopic: (string, Object) => void,
  addNewTopic: (string, Object) => void,
  search: (string) => void,
  setTab: (number) => void,
  redirect: (string) => void,
  selectedTab: number,
  isSearching: boolean,
  searchResults: ?List<Map<string, any>>,
  showMessage: (string) => void,
  url: string,
  isAdmin: boolean,
  isModal?: boolean,
};

class HelpCard extends Component<Props> {
  lastDto: ?Map<string, any> = null;

  componentDidMount() {
    const { dto, action } = this.props;
    // load only if not loaded already
    if (!dto) {
      action();
    }
  }

  componentDidUpdate(prevProps: Props) {
    // we store the last dto to preserve current menu and avoid flash of content
    if (prevProps.dto) this.lastDto = prevProps.dto;
    const {
      topicKey,
      dto,
      action,
      selectedTab,
      setTab,
      isSearching,
      searchResults,
    } = this.props;
    // if key changed, reload
    if (topicKey !== prevProps.topicKey) {
      if (selectedTab !== 0) {
        setTab(0);
      }
      if (!dto) {
        action();
      }
    }
    // if searching ended and we have some results, set relevant tab
    if (
      prevProps.isSearching &&
      !isSearching &&
      searchResults &&
      searchResults.size > 0
    ) {
      setTab(2);
    }
  }

  render() {
    const {
      topicKey,
      redirect,
      selectedTab,
      isSearching,
      searchResults,
      setTab,
      search,
      showMessage,
      url,
      isAdmin,
      isModal,
    } = this.props;
    const dto = this.props.dto ? this.props.dto : this.lastDto;
    if (!dto) {
      return <LoaderBig />;
    }
    return (
      <Paper elevation={2} elevation={0}>
        <Grid container>
          <Grid item xs={12}>
            <HelpToolbar
              breadcrumbs={dto.get("breadcrumbs")}
              onSubmit={search}
              url={url}
              redirect={redirect}
            />
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <HelpMenu
              title={dto.get("menuTitle")}
              subTopics={dto.get("subTopics")}
              redirect={redirect}
              breadcrumbs={dto.get("breadcrumbs")}
              url={url}
            />
          </Grid>
          <Grid item xs={12} md={8} lg={9}>
            <HelpContent
              topicKey={topicKey}
              id={dto.get("id")}
              title={dto.get("title")}
              hint={dto.get("hint")}
              selectedTab={selectedTab}
              isSearching={isSearching}
              searchResults={searchResults}
              setTab={setTab}
              showMessage={showMessage}
              url={url}
              isAdmin={isAdmin}
              updateTopic={this.props.updateTopic}
              addNewTopic={this.props.addNewTopic}
              redirect={redirect}
              isModal={isModal}
            />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default HelpCard;
